module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.messages), function(message) {
    return _c('communication-watcher', {
      key: message.id,
      attrs: {
        "message-id": message.id
      }
    })
  }), _vm._v(" "), (_vm.messages && _vm.messages.length === 0) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "width": "2"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n        Waiting for status updates ...\n      ")])], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-589788c0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communications/BatchIdList.vue
// module id = 1434
// module chunks = 9